import { ButtonList } from '@dixa/lib-shared-habla';
import { Conversation } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { Link } from 'react-router-dom';

import { createSearchUrl } from 'app/views/layout/views/search/utils';

type PropsT = {
  csid: number;
  userId: string | null;
  profileId: string;
  conversation: Conversation;
  transferToQueueModalOpen: (number) => any;
};

const isTransferAllowed = (conversation: Conversation, profileId: string) => {
  const { assignment, status, direction, requested_by } = conversation;
  if (!assignment) {
    return true;
  }

  if (['closed', 'pending', 'awaitingpending'].includes(status as any)) {
    return true;
  }

  return (
    assignment.agent_id === profileId ||
    (direction === 'internal' && requested_by === profileId) // Internal call started by ourself
  );
};

const ActionsDropdown = ({
  csid,
  userId,
  profileId,
  conversation,
  transferToQueueModalOpen,
}: PropsT) => {
  const searchUrlWithContactFilter = createSearchUrl({
    scope: 'conversations',
    filters: {
      strategy: 'all',
      conditions: [
        {
          field: 'requested_by',
          operator: 'is_one',
          values: [{ label: '', value: userId ?? '' }],
        },
      ],
    },
  });

  return (
    <ButtonList>
      <Link
        to={`/conversation/${csid}`}
        onClick={() =>
          ampli.teamConversationActionsMenuItemClicked({
            type: 'conversation',
          })
        }
      >
        <ButtonList.Item icon="chat">Go to conversation</ButtonList.Item>
      </Link>
      {isTransferAllowed(conversation, profileId) && (
        <ButtonList.Item
          icon="arrow-right"
          onClick={(e) => {
            e.preventDefault();
            transferToQueueModalOpen(csid);
            ampli.teamConversationActionsMenuItemClicked({
              type: 'transferToQueue',
            });
          }}
        >
          Transfer to queue
        </ButtonList.Item>
      )}
      <Link
        to={`/contacts/user/${userId}`}
        onClick={() =>
          ampli.teamConversationActionsMenuItemClicked({
            type: 'contact',
          })
        }
      >
        <ButtonList.Item icon="id-card">View contact</ButtonList.Item>
      </Link>
      <Link
        to={searchUrlWithContactFilter}
        onClick={() =>
          ampli.teamConversationActionsMenuItemClicked({
            type: 'contactConversations',
          })
        }
      >
        <ButtonList.Item icon="chat">
          Conversations with contact
        </ButtonList.Item>
      </Link>
    </ButtonList>
  );
};

export default ActionsDropdown;
